import '../styles/globals.css'
import '../styles/antd-custom.css'
import 'react-toastify/dist/ReactToastify.css';
import 'react-responsive-modal/styles.css';
import {Provider} from 'react-redux'
import type {AppProps} from 'next/app'
import Head from 'next/head'
import store from '../app/store'
import React, {useEffect} from "react"
import { QueryClient, QueryClientProvider } from "react-query";
import i18n from "@app/i18n";
import MainLoading from '@shares/MainLoading'
i18n.changeLanguage('en').then()
const queryClient = new QueryClient()

export default function MyApp({ Component, pageProps }: AppProps) {
  useEffect(() => {
    if(pageProps?.countrySPL) {
      i18n.changeLanguage(pageProps.countrySPL).then()
    }
  }, [])

  return (
    <QueryClientProvider client={queryClient}>
      <Provider store={store}>
        <Head>
          <title />
          <meta
            key={'meta_viewport'}
            name="viewport"
            content="minimum-scale=1, initial-scale=1, user-scalable=0, width=device-width, shrink-to-fit=no, maximum-scale=1.0"
          />
        </Head>
          <Component {...pageProps} />
        <MainLoading />
      </Provider>
    </QueryClientProvider>
  )
}
